import "./comingSoon.css";

const ComingSoon = ({ title }) => {
  return (
    <div className="comingsoon-page">
      <div className="comingsoon-content">
        {/* <img src="/logo-new.png" className="log" alt="logo dark" /> */}
        <h1>{title}</h1>
        <h1>Coming Soon...</h1>
      </div>
    </div>
  );
};

export default ComingSoon;
